import { TabsManager } from './TabsManager';
import type { BaseTab, TabsState } from './sidepanel-types';

/**
 * Factory function that creates a new TabsManager instance.
 * Each call returns a fresh instance with its own internal state store.
 *
 * @param baseTabs - Array of base tab configurations with stable IDs
 * @param initial - Optional initial state values
 * @returns A new TabsManager instance
 */
export const createTabsManager = (baseTabs: BaseTab[], initial?: Partial<TabsState>): TabsManager => {
	return new TabsManager(baseTabs, initial);
};
